const body = document.querySelector('body')
const menu = document.querySelector('.asside-menu')
const menuButton = document.querySelector('.asside-menu__mobile')
const menuContent = document.querySelector('.asside-menu__desctop')
const closeMenuButton = document.querySelector('.asside-menu__overlay')
const windowInnerHeight = window.innerHeight

function openAssideMenu() {
    const buttonBottom = menuButton.getBoundingClientRect().bottom

    menu.classList.remove('hide')
    menu.classList.add('open')
    body.classList.add('no-scroll')
    menuContent.style.maxHeight = 'calc(' + windowInnerHeight + 'px - 50px - 12px - ' + buttonBottom + 'px)'
}
function closeAssideMenu() {
    menu.classList.remove('open')
    menu.classList.add('hide')
    body.classList.remove('no-scroll')
    menuContent.style = ''
}

if(menuButton) {
    menuButton.addEventListener('click', () => {
        if (menu.classList.contains('open')) {
            closeAssideMenu()
        } else {
            openAssideMenu()
        }
    })
}
if(closeMenuButton) {
    closeMenuButton.addEventListener('click', () => closeAssideMenu())
}
